<template>
    <div class="fst-ssTemplateEditor admin-content">
        <h3 class="mt-0">SmartSearch Templates Editor</h3>
        <div class="filter">
            <el-select :value="sT"
                       style="width: 388px"
                       @change="handleSelectTemplate"
                       value-key="id"
                       popper-class="templateSelect"
                       placeholder="Выберите шаблон">
                <el-option v-for="(tpl, key) in templates"
                           :label="`${tpl.name} (${tpl.id})`"
                           :value="tpl"
                           :key="key">
                    <div class="title">{{tpl.name}}</div>
                    <div class="desc" v-if="tpl.description"
                         v-html="tpl.description"></div>
                </el-option>
            </el-select>
            <!--el-button type="primary" @click="handleSaveTemplate">
                <i class="fal fa-save mr-1"></i>
                Сохранить
            </el-button-->
            <el-button type="success" title="Новый шаблон" plain class="ml-0" @click="handleResetTemplate">
                <i class="fas fa-plus"></i>
            </el-button>
        </div>

        <!-----------------------  || FILTER || ----------------------------->

        <div v-loading.fullscreen.lock="loading" data-role="result">
            <div class="flex-top gap-15">
                <div>
                    <el-input v-model="sT.name" placeholder="Название шаблона"
                              style="width: 600px"
                              class="mb-2" clearable></el-input>
                    <div>
                        <el-checkbox v-model="isTemplateActive" label="Шаблон активен"/>
                    </div>

                </div>
                <el-input v-model="sT.description" placeholder="Описание"
                          style="width: 600px" type="textarea" rows="3"
                          class="mb-3" clearable></el-input>

            </div>
            <!---------------  = PARAMS = --------------->
            <el-collapse class="params">
                <el-collapse-item title="Настройки генерации уточненного вопроса">
                    <llm-block :llm="sT.queryOptions.refine.llm || cloneDeep(llmDefault)"/>
                </el-collapse-item>
                <el-collapse-item title="Настройки генерации запроса поиска документов">
                    <div class="multiLlm">
                        <div>
                            <llm-block v-for="(block, lK) in sT.queryOptions.query.llm || [cloneDeep(llmDefault)]"
                                       :llm="block"
                                       :key="lK"></llm-block>
                        </div>
                        <el-button type="primary" plain @click="handleAddLlm">
                            <i class="fal fa-plus"></i>
                        </el-button>
                    </div>
                    <!--llm-block :llm="sT.queryOptions.query.llm"
                               title="Настройка LLM для конвертации вопроса пользователя в запрос к teqviser"></llm-block-->
                    <div class="mt-3">
                        <span class="mr-2">Количество обращений к LLM на генерацию запроса</span>
                        <el-input-number v-model="sT.queryOptions.query.llmInvokeLimit" :min="1" clearable
                                         placeholder="Количество обращений к LLM на генерацию запроса"/>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="Настройки поиска документов">
                    <h3 class="mb-1 mt-0">Лимиты по поиску</h3>
                    <div class="mb-2">
                        <span class="mr-2">Количество документов, передаваемое в сеть для формирования ответа сети</span>
                        <el-input-number v-model="sT.queryOptions.search.limits.result" :min="0" :step="10"/>
                    </div>
                    <div class="mb-2">
                        <span class="mr-2">Количество документов, возвращаемое полнотекстовым движком (по умолчанию равно количеству документов, передаваемых в сеть для формирования ответа сети)</span>
                        <el-input-number v-model="sT.queryOptions.search.limits.text" :min="0" :step="10"/>
                    </div>
                    <!--
                                        <div class="mb-2">
                                            <span class="mr-2">Степень похожести дублей</span>
                                            <el-checkbox v-model="removeDuplicates.enabled"/>
                                            <span class="mr-2">Отбрасывать дубли и похожие документы</span>
                                            <el-input-number
                                                    v-model="removeDuplicates.similarity"
                                                    :min="0" :max="1" :step="0.1" :precision="2"
                                                    :disabled="!removeDuplicates.enabled"
                                            />
                                        </div>
                    -->
                    <div class="mb-2">
                        <span class="mr-2">Количество документов, передаваемое в пересортировку (по умолчанию 0, не пересортировывать)</span>
                        <el-input-number v-model="sT.queryOptions.search.limits.rescore" :min="0" :step="10"/>
                    </div>
                    <template
                            v-if="sT.queryOptions.search && sT.queryOptions.search.limits && sT.queryOptions.search.limits.rescore">
                        <llm-block :llm="sT.queryOptions.search.rescore.llm || cloneDeep(llmDefault)"
                                   title="Нейросеть переранжирования"/>
                        <div class="mt-3">
                            <span class="mr-2">Тип формирования ТОПа для отправления на переражирования</span>
                            <el-select v-model="sT.queryOptions.search.rescore.order" defaultFirstOption>
                                <el-option value="Through" label="Сквозной"/>
                                <el-option value="Proportional" label="Пропорциональный"/>
                            </el-select>
                        </div>
                    </template>
                </el-collapse-item>
                <el-collapse-item title="Настройки генерации результата">
                    <pre v-show="false">{{sT.queryOptions.result.llm}}</pre>
                    <llm-block :llm="sT.queryOptions.result.llm"
                               title="Настройка LLM для генерации результата ответа на prompt и найденные чанки"></llm-block>
                    <div>
                        <h3 class="mb-1">Шаблон генерации текста из найденного документа.</h3>
                        <div>Можно указать следующие поля: <br>
                            index, number, id, source, score, date, title, text
                        </div>
                        <el-input v-model="sT.queryOptions.result.documentRenderTemplate"
                                  type="textarea" rows="5"
                                  style="width: 800px"
                        ></el-input>
                    </div>
                    <div>
                        <h3 class="mb-1">Паттерн поиска номеров чанков в тексте ответа, для подмены их на ссылку на
                            документы</h3>
                        <el-input v-model="sT.queryOptions.result.documentLinkReplacePattern"
                                  style="width: 800px"
                        ></el-input>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="Настройки поиска по инвестициям">
                    <llm-block :llm="sT.queryOptions.investment.llm || cloneDeep(llmDefault)"
                               title="Настройка LLM генерации ответа при поиске по инвестициям"/>
                </el-collapse-item>
            </el-collapse>
            <div class="mb-4">
                <el-checkbox class="mr-3" v-if="sT.id"
                             v-model="saveAsCopy">Сохранить как копию
                </el-checkbox>
                <el-button type="primary" @click="handleSaveTemplate">
                    <i class="fal fa-save mr-1"></i>
                    Сохранить
                </el-button>
                <el-button type="danger" v-if="sT.id" @click="handleDeleteTemplate" plain>
                    <i class="fal fa-trash-alt mr-1"></i>
                    Удалить
                </el-button>
                <el-button type="primary" @click="handleCancel" plain>
                    <i class="fal fa-times mr-1"></i>
                    Отмена
                </el-button>
            </div>
        </div>
    </div>

</template>

<script>
    import {mapState} from "vuex";
    import moment from 'moment';
    import _ from "lodash";
    import LlmBlock from "./LlmBlock.vue";
    import Mixins from "../../../components/common/mixin";

    const llmDefault = {
            // Альяс llm
            "llm": "",
            // Альяс шаблона llm
            "template": "",
            // Маппинг параметров умного поиска (input и docs) на параметры шаблона llm
            // по умолчанию:
            //   - input один из следующих параметров: "input", "prompt", "query", "request"
            //   - docs один из следующих параметров: "docs", "documents", "texts", "doc", "document", "text"
            "paramsMapping": {
                "input": "input",
                "docs": "docs"
            },
            // Тут шаблону можно настроить другие его параметры
            "params": {}
        },
        templateDefault = {
            name: '',
            system: true,
            queryOptions: {
                refine: {
                    llm: _.cloneDeep(llmDefault)
                },
                query: {
                    "llm": [_.cloneDeep(llmDefault)],
                    "llmInvokeLimit": null,
                },
                result: {
                    // Настройка LLM для генерации результата ответа на prompt и найденные чанки
                    "llm": _.cloneDeep(llmDefault),
                    // Шаблон генерации текста из найденного чанка. Можно указать следующие поля:
                    // index, number, id, chunkIndex, source, score, date, docType, language, range, text, highlight, highlight_or_text
                    "documentRenderTemplate": '#Text_${index!}\n${title!}\n${description!}',
                    // Паттерн поиска номеров чанков в тексте ответа, для подмены их на ссылку на документы
                    "documentLinkReplacePattern": "(#Text[_ ]+[0-9]+#?)|(#[0-9]+#?)"
                },
                search: {
                    // Лимиты по поиску
                    "limits": {
                        // Количество документов, передаваемое в сеть для формирования ответа сети (по умолчанию 10)
                        "result": 10,
                        // Количество документов, возвращаемое полнотекстовым движком
                        "text": 10,
                        // Количество документов, передаваемое в пересортировку (по умолчанию 0, не пересортировывать)
                        "rescore": 0
                    },
                    // Отбрасывать дубли и похожие документы
                    removeDuplicates: {
                        // Максимальная похожесть чанков с которой они не считаются дублями. Предполагает значение от 0 до 1.
                        similarity: null
                    },
                    // Настройки переранжирования
                    "rescore": {
                        // Настройка нейросети переранжирования
                        llm: _.cloneDeep(llmDefault),
                        order: 'Through'
                    }
                },
                investment: {
                    llm: _.cloneDeep(llmDefault)
                }
            }
        }
    ;

    export default {
        name: "SSTemplatesEditor",
        components: {LlmBlock},
        mixins: [Mixins],
        props: {
            selectedTemplateId: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                sT: _.cloneDeep(templateDefault),
                llmDefault: _.cloneDeep(llmDefault),
                templateDefault: _.cloneDeep(templateDefault),
                loading: false,
                removeDuplicates: {
                    enabled: false,
                    similarity: 0.9
                },
                saveAsCopy: false,
            }
        },
        mounted() {
            this.refresh();
        },
        computed: {
            ...mapState('smartSearch', ['templates', 'llms']),
            ...mapState({
                userInfo: state => state.userInfo,
            }),
            isTemplateActive: {
                get() {
                    return !this.sT.system;
                },
                set(value) {
                    this.sT.system = !value;
                }
            }
        },
        methods: {
            refresh() {
                this.loading = true;
                console.log('user ', this.userInfo);
                Promise.all([
                    this.$store.dispatch('smartSearch/getTemplates'),
                    this.$store.dispatch('smartSearch/getLlms'),
                ]).then(() => {
                    const st = this.templates.find(it => it.id === this.selectedTemplateId) || _.cloneDeep(templateDefault);
                    st.queryOptions.search.rescore = st.queryOptions.search.rescore.llm ? st.queryOptions.search.rescore : {llm: _.cloneDeep(llmDefault)}
                    this.removeDuplicates.similarity = _.get(st, 'queryOptions.search.removeDuplicates.similarity');
                    this.removeDuplicates.enabled = !!this.removeDuplicates.similarity;
                    if (!this.removeDuplicates.enabled) {
                        this.removeDuplicates.similarity = 0.9;
                    }
                    st.queryOptions.query.llm = Array.isArray(st.queryOptions.query.llm) ? st.queryOptions.query.llm : [st.queryOptions.query.llm]
                    this.sT = st
                    this.$nextTick(() => {
                        document.querySelector('[data-role="result"]').scrollTo({
                            top: 0,
                            behavior: "smooth"
                        });
                    })
                }).finally(() => {
                    this.loading = false;
                });
            },
            handleSelectTemplate(tpl) {
                this._lastLoaded = _.cloneDeep(tpl)
                tpl.queryOptions.query.llm = Array.isArray(tpl.queryOptions.query.llm) ? tpl.queryOptions.query.llm : [tpl.queryOptions.query.llm]
                this.sT = _.defaultsDeep(tpl, templateDefault);
                console.log('selected Tpl Options=== ', tpl.queryOptions, ' | sT:', this.sT.queryOptions);
            },
            handleSaveTemplate() {
                const st = _.cloneDeep(this.sT);
                st.name = st.name || `${('Шаблон (' + this.userInfo.fullName + ')')} - ${moment().format('DD.MM.YYYY HH:mm')}`
                if (this.removeDuplicates.enabled && this.removeDuplicates.similarity) {
                    st.queryOptions.search.removeDuplicates = {similarity: this.removeDuplicates.similarity};
                } else {
                    delete st.queryOptions.search.removeDuplicates;
                }
                st.id = this.saveAsCopy ? null : st.id;
                st.name = this.saveAsCopy ? st.name + ' Copy' : st.name;
                this.loading = true;
                ['refine', 'query', 'result', 'search', 'investment'].forEach(item => {
                    let _llm = st.queryOptions[item]?.llm || st.queryOptions[item]?.rescore?.llm || {}
                    if (!_llm.template && !Array.isArray(_llm)) {
                        delete st.queryOptions[item].llm
                        delete st.queryOptions[item]?.rescore?.llm
                    }
                })
                this.$services.smartsearch_template.save(st).prepare().then(resp => {
                    this._lastLoaded = _.cloneDeep(resp.data);
                    this.$store.commit('smartSearch/updateTemplate', resp.data);
                    this.$emit('selectedTemplate', resp.data)
                    this.sT = _.defaultsDeep(resp.data, templateDefault);
                    console.log('sT:::::', this.sT);
                }, err => {
                    this.handleError(err);
                }).finally(() => {
                    setTimeout(() => {
                        this.loading = false;
                    }, 500)
                })
            },
            handleDeleteTemplate() {
                this.$confirm(`Удалить шаблон "${this.sT.name}"?`, 'Внимание', {
                    confirmButtonText: 'Удалить',
                    cancelButtonText: 'Отмена',
                    type: 'warning'
                }).then(() => {
                    this.$services.smartsearch_template.delete({ids: [this.sT.id]}).prepare().then(() => {
                        this.$message({
                            message: 'Шаблон удален',
                            type: 'success'
                        });
                        this.sT.delete = true;
                        this.$store.commit('smartSearch/updateTemplate', this.sT)
                        this.$nextTick(() => {
                            this.handleResetTemplate();
                        })
                    }, err => {
                        this.handleError(err);
                    });
                }).catch(() => {
                    console.log('Del cancelled')
                });
            },
            handleResetTemplate() {
                this.sT = _.cloneDeep(templateDefault)
                this._lastLoaded = null;
            },
            handleCancel() {
                if (this._lastLoaded) {
                    this.handleSelectTemplate(this._lastLoaded);
                } else {
                    this.handleResetTemplate();
                }
            },
            updateLlm(path, val) {
                _.set(this.sT, path, val);
            },
            handleAddLlm() {
                this.sT.queryOptions.query.llm.push(_.cloneDeep(llmDefault));
            },
            cloneDeep(obj) {
                return _.cloneDeep(obj);
            }
        }

    }
</script>

<style lang="scss">
    /*@import '../styles/layout';*/
    @use "@/assets/variables.scss" as *;

    .fst-ssTemplateEditor {
        .filter {
            display: flex;
            align-items: center;
            gap: 15px;
            margin-bottom: 15px;
        }

        .multiLlm {
            display: flex;
            gap: 15px;
            align-items: flex-end;
        }

        .el-collapse-item__header {
            font-size: 16px;
            color: $iq-color-primary;
            transition: all .3s ease;

            &.is-active {
                background: $iq-color-primary;
                color: white;
                padding-left: 10px;
                margin-bottom: 10px;
            }
        }

        .params {
            margin-bottom: 20px;

            label {
                display: inline-block;
                margin-right: 7px;
                font-size: .9rem;
            }

            article + article {
                margin-top: 10px;
                padding-top: 10px;
                border-top: 1px solid #ddd;
            }
        }

        .inlineBlock {
            display: flex;
            gap: 20px;
        }

        .el-collapse-item + .el-collapse-item {
            border-top: 1px solid #ddd;
        }

        .el-textarea__inner {
            background: #ffffff;
        }

        .params {
            margin: 20px 0;
        }

        .el-collapse-item__content {
            font-size: 14px;
        }
    }

</style>
